import { render, staticRenderFns } from "./Ppt.vue?vue&type=template&id=ebd6941e&"
import script from "./Ppt.vue?vue&type=script&lang=js&"
export * from "./Ppt.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports